export default __webpack_public_path__ + "static/media/Ksyusha.b00e0056.png";